<!--底部菜单模块-->

<template>
	<nav :class="['c_menu', { 'new-menu': isNewStyle }]">
		<ul>
			<li v-for="item in navLIst" :key="item.key" :class="current == item.key ? 'cur' : ''">
				<template v-if="item.key != 'release'">
					<router-link :to="item.path">
						<i :class="['iconfont', item.icon]"></i>
						<span>{{ item.name }}</span>
					</router-link>
				</template>
				<template v-else>
					<a
						:href="
							'https://static.xubei.com/act/download0418/' +
							download +
							'?source=h5&channel=' +
							channel +
							'&f=' +
							fChannel +
							'&userId=' +
							userId
						"
						@click="appLoad"
					>
						<i class="iconfont">&#xe64f;</i>
						<span>APP下载</span>
					</a>
				</template>
			</li>
		</ul>
	</nav>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { NEW_HOME_DOMAIN_NAME } from '@/config/constants';
export default {
	data() {
		return {
			source: localStorage.getItem('source') || '',
			channel: this.$store.state.channel || '',
			userId: '',
			download: 'downloadH5.html',
			fChannel: '',
			navLIst: [
				{ key: 'index', name: '首页', path: '/', icon: 'homeIcon' },
				{ key: 'rent', name: '租号', path: '/goodsAll', icon: 'goodsIcon' },
				{ key: 'release', name: 'APP下载', path: '', icon: 'appIcon' },
				{
					key: 'order',
					name: '订单',
					path: '/my_order?orderType=0',
					icon: 'orderIcon'
				},
				{ key: 'my', name: '我的', path: '/my', icon: 'myIcon' }
			],
			isNewStyle: false
		};
	},
	props: ['current'],
	created() {
		this.fChannel = sessionStorage.getItem('newChannel') || '+++++4';
	},
	mounted() {
		if (this.$route.query.channel && this.$route.query.channel == 'Android_huodong_h5') {
			this.download = 'downloadH5New.html';
		}
		if (this.userInfo) {
			this.userId = this.userInfo.userid;
		}

		if (NEW_HOME_DOMAIN_NAME.includes(window.location.host)) {
			this.isNewStyle = true;
			this.navLIst = [
				{ key: 'index', name: '首页', path: '/', icon: 'homeIcon' },
				{ key: 'rent', name: '租号', path: '/goodsAll', icon: 'goodsIcon' },
				{ key: 'my', name: '我的', path: '/my', icon: 'myIcon' }
			];
		} else if (
			localStorage.getItem('zhwk') ||
			localStorage.getItem('shq') ||
			window.location.href.indexOf('zugehao.com') > -1 ||
			window.location.href.indexOf('zuhw.njweisid.cn') > -1 ||
			window.location.href.indexOf('zhw.whysjiaoyu.cn') > -1 ||
			window.location.href.indexOf('zhw.yunijy.com') > -1 ||
			window.location.href.indexOf('zhw.dreamgardenw.cn') > -1 ||
			window.location.href.indexOf('zhw.hjxgd.top') > -1 ||
			window.location.href.indexOf('zhw.zszlxx.cn') > -1 ||
			window.location.href.indexOf('zhw.hzcasl.com') > -1
		) {
			let index = this.navLIst.findIndex((v) => v.key == 'release');
			if (index > -1) {
				this.navLIst.splice(index, 1);
			}
		}
	},
	computed: {
		...mapState(['userInfo'])
	},
	methods: {
		appLoad() {}
	}
};
</script>

<style lang="scss" scoped>
@import '../../style/common';

.c_menu {
	border-top: 1px solid rgb(229, 229, 229);
	position: fixed;
	bottom: 0;
	width: 100%;
	height: px2rem(100rem);
	background: $c_ff;
	z-index: 10;
	ul {
		display: flex;
		height: 100%;

		li {
			flex: 1;
			text-align: center;

			> a {
				display: block;
				height: 100%;

				> i {
					@include font(48rem, #666);
					display: inline-block;
					margin-top: px2rem(10rem);
					width: px2rem(48rem);
					height: px2rem(48rem);
				}

				.homeIcon {
					background: url('../../images/menu/home.png') no-repeat center center;
					background-size: px2rem(48rem) px2rem(48rem);
				}

				.goodsIcon {
					background: url('../../images/menu/goods.png') no-repeat center center;
					background-size: px2rem(48rem) px2rem(48rem);
				}

				.orderIcon {
					background: url('../../images/menu/order.png') no-repeat center center;
					background-size: px2rem(48rem) px2rem(48rem);
				}

				.myIcon {
					background: url('../../images/menu/my.png') no-repeat center center;
					background-size: px2rem(48rem) px2rem(48rem);
				}

				> span {
					display: block;
					@include font(24rem, $c_gray);
				}
			}
		}

		li.cur {
			.homeIcon {
				background: url('../../images/menu/home_active.png') no-repeat center center;
				background-size: px2rem(48rem) px2rem(48rem);
			}

			.goodsIcon {
				background: url('../../images/menu/goods_active.png') no-repeat center center;
				background-size: px2rem(48rem) px2rem(48rem);
			}

			.orderIcon {
				background: url('../../images/menu/order_active.png') no-repeat center center;
				background-size: px2rem(48rem) px2rem(48rem);
			}

			.myIcon {
				background: url('../../images/menu/my_active.png') no-repeat center center;
				background-size: px2rem(48rem) px2rem(48rem);
			}

			span {
				color: $c_blue;
			}
		}
	}

	.dd-img {
		width: 0.48rem;
		height: 0.48rem;
		display: block;
	}
}

.new-menu {
	ul {
		li {
			> a {
				.iconfont {
					width: 0.36rem;
					height: 0.36rem;
					background: url('~@/images/new-home/nav-icon.png') no-repeat center center;
					background-size: 2.12rem 1.3rem;
				}
				.homeIcon {
					background-position: -0.38rem -0.74rem;
				}

				.goodsIcon {
					background-position: -0.9rem -0.74rem;
				}
				.myIcon {
					background-position: -1.42rem -0.74rem;
				}
				span {
					font-weight: 400;
					font-size: 0.22rem;
					color: #646775;
					line-height: 0.32rem;
				}
			}
		}
		li.cur {
			.iconfont {
				background: url('~@/images/new-home/nav-icon.png') no-repeat center center;
				background-size: 2.12rem 1.3rem;
			}
			.homeIcon {
				background-position: -0.38rem -0.18rem;
			}

			.goodsIcon {
				background-position: -0.9rem -0.18rem;
			}
			.myIcon {
				background-position: -1.42rem -0.18rem;
			}
			span {
				color: #313441;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue